import { MUIAccordionDetailsSt } from './AccordionDetails.css';
import { AccordionDetailsProps } from '@mui/material';
export default function AccordionDetails({
  children,
  ...rest
}: AccordionDetailsProps) {
  return <MUIAccordionDetailsSt {...rest}>{children}</MUIAccordionDetailsSt>;
}
